// extracted by mini-css-extract-plugin
module.exports = {"rows":"DevDebugInfoPanel_rows__U1EMw","row":"DevDebugInfoPanel_row__8uHyL","labels":"DevDebugInfoPanel_labels__dwEKP","value":"DevDebugInfoPanel_value__0Pr0D"};